import { useCallback } from 'react';

import type { InvestorFirms_AddContactMutationVariables } from '../../../graphql/__generated__';
import {
  useInvestorFirms_AddContactMutation,
  useInvestorFirms_AdminAddContactMutation,
} from '../../../graphql/__generated__';
import { refetchQueriesAfterContactCreation } from '../AddInvestorContact.model';

export function useAddInvestorFirmsContact(tenantId?: string) {
  const [addInvestorFirmContactAsCustomer, { error: errorCustomer }] =
    useInvestorFirms_AddContactMutation({
      refetchQueries: refetchQueriesAfterContactCreation,
    });

  const [addInvestorFirmContactAsAdmin, { error: errorAdmin }] =
    useInvestorFirms_AdminAddContactMutation({
      refetchQueries: refetchQueriesAfterContactCreation,
    });

  const addInvestorFirmContact = useCallback(
    async (variables: InvestorFirms_AddContactMutationVariables) => {
      if (tenantId) {
        return await addInvestorFirmContactAsAdmin({
          variables: {
            input: {
              tenantId,
              ...variables.input,
            },
          },
        });
      } else {
        return addInvestorFirmContactAsCustomer({ variables });
      }
    },
    [tenantId, addInvestorFirmContactAsAdmin, addInvestorFirmContactAsCustomer]
  );

  return {
    addInvestorFirmContact,
    error: errorAdmin || errorCustomer,
  };
}
